import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MessageSquare, Sparkles, FileSearch, TrendingUp, ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import logo from "@/assets/whatai-logo.png";

const Index = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="bg-gradient-subtle">
      {/* Hero Section */}
      <section className="container mx-auto px-4 py-12 sm:py-16 md:py-20 text-center">
        <img 
          src={logo} 
          alt="WhatAI Logo" 
          className="w-24 sm:w-32 mx-auto mb-6 sm:mb-8 animate-in fade-in zoom-in"
        />
        
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 sm:mb-6 animate-in fade-in slide-in-from-bottom-4 px-4">
          <span className="text-primary">
            {t("index.title")}
          </span>
        </h1>
        
        <p className="text-base sm:text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8 sm:mb-12 animate-in fade-in slide-in-from-bottom-8 px-4">
          {t("index.subtitle")}
        </p>

        <Button
          onClick={() => navigate("/auth")}
          size="lg"
          className="gradient-primary text-white px-6 py-4 sm:px-8 sm:py-6 text-base sm:text-lg shadow-elegant hover:opacity-90 transition-smooth animate-in fade-in slide-in-from-bottom-12"
        >
          {t("index.getStarted")}
          <ArrowRight className="mr-2 w-4 h-4 sm:w-5 sm:h-5" />
        </Button>
      </section>

      {/* Features */}
      <section className="container mx-auto px-4 py-8 sm:py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          <div className="bg-card rounded-2xl p-6 shadow-soft transition-smooth hover:shadow-elegant animate-in fade-in slide-in-from-bottom-2">
            <div className="w-12 h-12 gradient-primary rounded-xl flex items-center justify-center mb-4">
              <MessageSquare className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-lg font-bold mb-2">{t("index.feature1.title")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("index.feature1.desc")}
            </p>
          </div>

          <div className="bg-card rounded-2xl p-6 shadow-soft transition-smooth hover:shadow-elegant animate-in fade-in slide-in-from-bottom-4">
            <div className="w-12 h-12 gradient-accent rounded-xl flex items-center justify-center mb-4">
              <Sparkles className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-lg font-bold mb-2">{t("index.feature2.title")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("index.feature2.desc")}
            </p>
          </div>

          <div className="bg-card rounded-2xl p-6 shadow-soft transition-smooth hover:shadow-elegant animate-in fade-in slide-in-from-bottom-6">
            <div className="w-12 h-12 gradient-primary rounded-xl flex items-center justify-center mb-4">
              <FileSearch className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-lg font-bold mb-2">{t("index.feature3.title")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("index.feature3.desc")}
            </p>
          </div>

          <div className="bg-card rounded-2xl p-6 shadow-soft transition-smooth hover:shadow-elegant animate-in fade-in slide-in-from-bottom-8">
            <div className="w-12 h-12 gradient-accent rounded-xl flex items-center justify-center mb-4">
              <TrendingUp className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-lg font-bold mb-2">{t("index.feature4.title")}</h2>
            <p className="text-sm text-muted-foreground">
              {t("index.feature4.desc")}
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="container mx-auto px-4 py-8 sm:py-12 md:py-16 text-center">
        <div className="bg-card rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 shadow-elegant max-w-4xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4 px-4">{t("index.cta.title")}</h2>
          <p className="text-sm sm:text-base text-muted-foreground mb-6 sm:mb-8 px-4">
            {t("index.cta.subtitle")}
          </p>
          <Button
            onClick={() => navigate("/auth")}
            size="lg"
            className="gradient-primary text-white px-6 py-4 sm:px-8 sm:py-6 text-base sm:text-lg shadow-elegant hover:opacity-90 transition-smooth"
          >
            {t("index.cta.button")}
            <ArrowRight className="mr-2 w-4 h-4 sm:w-5 sm:h-5" />
          </Button>
        </div>
      </section>
      </div>
  );
};

export default Index;
